import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {LeadStatusDto} from "../model/LeadStatusDto";

class LeadStatusSelectController implements IComponentController {
    records: LeadStatusDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllLeadStatus(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.leadStatusSubscribeAndQuery().then(ret => this.records = ret);
    };

    $onInit(): void {
    }

    $onDestroy() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.leadStatusSelect', [])
    .component('leadStatusSelect', {
        template: require('./LeadStatusSelect.html'),
        controller: LeadStatusSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
